export default {
  MEMBER_REVENUE_DATA (state, data) {
    state.member_revenue_data = data
  },
  VOLUNTEER_REVENUE_DATA (state, data) {
    state.volunteer_revenue_data = data
  },
  DONATIONS_REVENUE_DATA (state, data) {
    state.donations_revenue_data = data.data
  },
  BOOKINGS_REVENUE_DATA(state, data) {

    state.bookings_total = data.data.bookings_total
   
    state.bookings_revenue = data.data.bookings_revenue
    state.bookings_discounts = data.data.bookings_discounts
    state.transaction_data = data.data.transaction_data
    state.discount_total = data.data.discount_total
  },
  RESIDENCY_REVENUE_DATA(state, data) {
    state.residency_count = data.data.residency_count
    state.residency_bed_nights = data.data.residency_bed_nights
    state.residency_revenue = data.data.residency_revenue
    state.residency_discounts = data.data.residency_discounts
    state.residency_tabular = data.data.residency_tabular
    state.residency_totals = data.data.residency_totals
  },

  VEHICLE_REVENUE_DATA(state, data) {
    state.vehicle_count = data.data.vehicle_count
    state.vehicle_revenue = data.data.vehicle_revenue
    state.vehicle_discounts = data.data.vehicle_discounts
    state.vehicle_bed_nights = data.data.vehicle_bed_nights
    state.vehicle_tabular = data.data.vehicle_tabular
    state.vehicle_totals = data.data.vehicle_totals
  },
  INVENTORY_REVENUE_DATA(state, data) {
    state.inventory_net_base = data.data.net_base
    state.inventory_discount_net_base = data.data.discount_net_base
    state.inventory_revenue = data.data.inventory_revenue
    state.inventory_discounts = data.data.inventory_discounts
    state.inventory_tabular_data = data.data.inventory_tabular_data
    state.inventory_count = data.data.inventory_count
    state.inventory_bed_night = data.data.inventory_bed_night
    state.inventory_totals = data.data.inventory_totals
    
  },
  TRANSACTIONS_REPORT_DATA(state, data) {

    state.transaction_data = data.data.transaction_data
    state.transaction_total = data.data.transaction_total
  },
}
